import { render } from "./HomeGreen.vue?vue&type=template&id=05ecdeb0"
import script from "./HomeGreen.vue?vue&type=script&lang=js"
export * from "./HomeGreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__